export const normalize = (str) => {
    if (typeof str !== 'string') {
        return '';
    }
    return str.toLowerCase().replace(/\s+/g, '');
};

export const adapterBlogSlug = (blogSlug = '', noNormalize) => {
    const redirects = {
        ai: 'aiInCms',
        developers: 'technicalGuides',
        'content-management': 'contentManagement'
    };

    if (noNormalize) {
        const result = redirects[blogSlug] || blogSlug;
        return result;
    }

    const result = normalize(redirects[blogSlug] || blogSlug);
    return result;
};

const slugifyCategory = (str) => (str || '').toLowerCase().trim().replace(/\s+/g, '-');

export const adaptCategories = (categories) => {
    if (!categories || !Array.isArray(categories)) {
        return [];
    }

    const valueMapping = {
        'Technical Guides': 'Developers',
        'AI in CMS': 'ai'
    };

    return categories.map((category) => {
        const name = category?.name || '';
        return {
            key: name,
            value: name,
            adaptedValue: slugifyCategory(valueMapping[name] || name)
        };
    });
};
